const DeActiveMaterial = (props: any) => {
  const color = props.color || "var(--theme-primary-color, #2E3092)";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0874 1.00003H4.34876C2.49929 1.00003 1 2.59881 1 4.57101C1 6.54321 2.49929 8.14199 4.34876 8.14199H11.0874C12.9369 8.14199 14.4362 6.54321 14.4362 4.57101C14.4362 2.59881 12.9369 1.00003 11.0874 1.00003Z"
        stroke={color}
        stroke-miterlimit="10"
      />
      <path
        d="M4.56962 7.09464C5.87768 7.09464 6.93808 5.96388 6.93808 4.56902C6.93808 3.17415 5.87768 2.0434 4.56962 2.0434C3.26156 2.0434 2.20117 3.17415 2.20117 4.56902C2.20117 5.96388 3.26156 7.09464 4.56962 7.09464Z"
        fill={color}
      />
    </svg>
  );
};

export { DeActiveMaterial };
